// Connect transport and typed clients.
//
// Same-origin by default: in production the Go binary serves this bundle and
// the RPCs from one port, and in dev Vite proxies /amrec.v1.* to the backend
// (see vite.config.ts). So there is no base-URL configuration to get wrong and
// no CORS story.

import { createClient, type Client } from "@connectrpc/connect";
import { createConnectTransport } from "@connectrpc/connect-web";

import { CatalogService } from "../gen/amrec/v1/catalog_pb";
import { SearchService } from "../gen/amrec/v1/search_pb";
import { RecommendService } from "../gen/amrec/v1/recommend_pb";
import { CrawlService } from "../gen/amrec/v1/crawl_pb";

const transport = createConnectTransport({
  baseUrl: "/",
  // JSON over HTTP/1.1. The binary codec is faster but makes every request
  // opaque in devtools, which is the wrong trade for a personal tool whose
  // whole point is inspecting why a recommendation surfaced.
  useBinaryFormat: false,
});

export const catalogClient: Client<typeof CatalogService> = createClient(CatalogService, transport);
export const searchClient: Client<typeof SearchService> = createClient(SearchService, transport);
export const recommendClient: Client<typeof RecommendService> = createClient(RecommendService, transport);
export const crawlClient: Client<typeof CrawlService> = createClient(CrawlService, transport);
